import React from 'react';
import EmergencyIcon from '../icons/EmergencyIcon';
import { Box, makeStyles, Typography } from '@material-ui/core';
import BotaoImprimirNotaFiscal from './BotaoImprimirNotaFiscal';
import consts from '../../../main/consts';
import { sendGaEvent } from '../../../main/sendGaEvent';
import alertaStyles from './Alerta.styles';

const useStyles = makeStyles((theme) => ({
  alertBoxNf: {
    ...alertaStyles.alertBox,
    justifyContent: 'space-between',
    backgroundColor: '#F9F6C6',
    gap: '1rem',
  },
  alertTitle: {
    ...alertaStyles.alertTitle,
    fontSize: '18px',
  },
  alertSubtitle: {
    ...alertaStyles.alertSubtitle,
    fontSize: '16px',
  }
}));

function AlertaImprimirNotaFiscal({ canalDeVendas, notaFiscal, idPedido }) {
  const classes = useStyles();

  const imprimirNotaFiscal = (notaFiscal) => {
    const nfUrl = consts.NOTA_FISCAL_URL + notaFiscal.chave;

    window.open(nfUrl, '_blank');

    sendGaEvent('preview_invoice', 'ready-to-go', {
      sales_channel: canalDeVendas,
      order_id: idPedido,
      origin: 'imprimir-nota-fiscal'
    })
  }

  return (
    <Box className={classes.alertBoxNf}>
      <EmergencyIcon />
      <Box display={'flex'} flexDirection={'column'} flex={1}>
        <Typography variant="inherit" className={classes.alertTitle}>
          {notaFiscal ? <>Imprimir nota fiscal</> : <>Atenção: imprima a nota fiscal antes de enviar o pedido!</>}
        </Typography>
        <Typography variant="caption" className={classes.alertSubtitle}>
          {
            notaFiscal ? (
              <>
                Para pedidos com canal de venda {canalDeVendas}, é <strong>obrigatório imprimir e enviar a nota fiscal</strong> para o cliente.
              </>
            ) : (
              <>
                Aguarde a emissão da nota fiscal, <strong>imprima o documento e coloque junto ao pacote.</strong><br />
                Essa etapa é <strong>obrigatória</strong> para pedidos com o canal de venda {canalDeVendas}.
              </>
            )
          }
        </Typography>
      </Box>
      <Box display={'flex'} alignItems={'center'}>
        <BotaoImprimirNotaFiscal disabled={!notaFiscal} onClick={() => imprimirNotaFiscal(notaFiscal)} />
      </Box>
    </Box>
  )
}

export default AlertaImprimirNotaFiscal;